import axios from "../../axiosInstance";
import type { Badge } from "@/modules/learningCenter/features/BadgeManagement/types/badge.types";

export const activateBadge = async (id: string): Promise<Badge> => {
  const response = await axios.post<Badge>(`/api/badges/${id}/activate`);
  return response.data;
};

export default activateBadge;
